import request from '@/utils/http.js';

// // 获取挂件信息
// const getPendantInfo = params => {
//   return request('/v3/interacts/pendant/get-info', {
//     method: 'GET',
//     params
//   });
// };
const getCustomPendantInfo = params => {
  return request('/v3/interacts/third-components/get-components-info', {
    method: 'GET',
    params
  })
}

export default {
  // getPendantInfo,
  getCustomPendantInfo
};
